module.exports = __webpack_public_path__ + "img/case1.1b01e0dc.jpg";